export default function memberForm() {
    document.addEventListener('DOMContentLoaded', () => {
        const form = document.getElementById('get-access-form')
        const submitButton = form.querySelector('button[type="submit"]')
        const emailField = form.querySelector('[data-members-email]')

        // form status elements
        const statusField = document.querySelector('[data-members-status')

        emailField.addEventListener('click', () => {
            statusField.classList.add('hidden')
        })

        submitButton.addEventListener('click', async function (event) {
            event.preventDefault()
            submitButton.setAttribute('disabled', '')
            const memberEmail = emailField.value
            statusField.textContent = 'Loading '
            statusField.classList.remove('hidden')

            try {
                const response = await fetch('https://api.thob.studio/v1/contact/add', {
                    method: 'POST',
                    body: JSON.stringify({
                        email: memberEmail,
                    }),
                    headers: {
                        'Content-type': 'application/json',
                        Accept: 'application/json',
                    },
                })
                const data = await response.json()
                if (response.status === 201) {
                    let message =
                        data.code === 'duplicate_parameter'
                            ? 'we already have you on our list our team is working on getting you acces ASAP '
                            : ' Welcome to thob alpha '
                    statusField.classList.add('text-primary60')
                    statusField.textContent = message
                }
                if (response.status === 400) {
                    statusField.textContent = 'Please check if you have entered the email corrrectly'
                    statusField.classList.add('text-error60')
                }
            } catch (error) {
                statusField.textContent = 'something went wrong'
                statusField.classList.add('text-error60')
            } finally {
                submitButton.removeAttribute('disabled', '')
            }
        })
    })
}
